export const SETTINGS_PATH = '/settings';
export const PERSONAL_DATA_PATH = '/settings/personal_data';
export const PLAN_UPGRADE_PATH = '/settings/plan/upgrade';

export default [
	{
		path: SETTINGS_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Settings');
			return { Component: Module.default };
		},
	},
	{
		path: PERSONAL_DATA_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Settings/PersonalData');
			return { Component: Module.default };
		},
	},
	{
		path: PLAN_UPGRADE_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Settings/UpgradePlan');
			return { Component: Module.default };
		},
	},
];
